import { render, staticRenderFns } from "./academy_personal-data.vue?vue&type=template&id=511a002e&"
import script from "./academy_personal-data.vue?vue&type=script&lang=js&"
export * from "./academy_personal-data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ConstructorLayout: require('/home/smiley/3df/components/Constructor/ConstructorLayout.vue').default})
